module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/articles.json
// module id = 453
// module chunks = 56932394960959